import { useState, useEffect, useCallback } from "react"

import { Guid } from "@/types"
import AssetService from "services/AssetService"
import { GlobalAssetOverviewAsset } from "models/GlobalAssetOverviewAsset"
import toastMessages from "stores/toastMessages"

export default function useGlobalAssetOverviewAsset(assetId?: Guid | null, onFail?: () => void) {
    const [asset, setAsset] = useState<GlobalAssetOverviewAsset | null>(null)

    const fetchAsset = useCallback(async (id: Guid) => {
        setAsset(null)
        try {
            const fetchedAsset = await AssetService.getGlobalAssetOverviewAsset(id)
            setAsset(fetchedAsset)
        } catch(e) {
            console.log(e)
            toastMessages.showSystemError()
            onFail?.()
        }
    }, [onFail])


    useEffect(() => {
        if (!assetId) {
            setAsset(null)
            return
        }
        fetchAsset(assetId)
    }, [assetId, fetchAsset])

    return {
        asset,
    }
}
